/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof LoginResponse
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    refreshToken: string;
    /**
     * 
     * @type {Date}
     * @memberof LoginResponse
     */
    validTo: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoginResponse
     */
    roles: Array<string>;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof LoginResponse
     */
    tenantId: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the LoginResponse interface.
 */
export function instanceOfLoginResponse(value: object): value is LoginResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('validTo' in value) || value['validTo'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function LoginResponseFromJSON(json: any): LoginResponse {
    return LoginResponseFromJSONTyped(json, false);
}

export function LoginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'token': json['token'],
        'refreshToken': json['refreshToken'],
        'validTo': (new Date(json['validTo'])),
        'roles': json['roles'],
        'tenantId': ApiUserTasksGetPageParameterFromJSON(json['tenantId']),
    };
}

export function LoginResponseToJSON(json: any): LoginResponse {
    return LoginResponseToJSONTyped(json, false);
}

export function LoginResponseToJSONTyped(value?: LoginResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'token': value['token'],
        'refreshToken': value['refreshToken'],
        'validTo': value['validTo'].toISOString(),
        'roles': value['roles'],
        'tenantId': ApiUserTasksGetPageParameterToJSON(value['tenantId']),
    };
}

